<template>
  <div>
    <v-dialog v-model="localShowDialog" :width="950">
      <v-container column>
        <v-card
          color="#0d2340"
          class="pa-0 backgroundHolder"
          v-bind:style="{ 'background-image': 'url(' + backgroundImgSrc + ')' }"
        >
          <v-card-text class="pt-5 relative-position">
            <div class="flexContent">
              <div class="flexToolbar">
                <v-icon
                  color="#CDDB00"
                  size="18"
                  @click="localShowDialog = !localShowDialog"
                  class="cursor-pointer"
                  title="Close"
                  >fas fa-times</v-icon
                >
              </div>
              <div class="flexMain">
                <h2
                  class="highlighted-text application-heading text-center mb-5"
                >
                  Welcome to the new Control Risks' Global Risk Data platform,
                  powered by Seerist.
                </h2>
                <div class="welcom-message-content">
                  <div class="welcom-message-content-body">
                    <p class="text-main">
                      This new site is home to all Control Risks' special risks
                      analytical content, kidnap mitigation advice and
                      guidelines, as well as evacuation ratings.
                    </p>
                    <p class="text-main">
                      For questions regarding the content or Control Risks'
                      capabilities please contact
                      <a
                        href="mailto:specialrisksanalysis@controlrisks.com"
                        target="_blank"
                        >specialrisksanalysis@controlrisks.com</a
                      >.
                    </p>
                    <div class="acceptBoxHolder">
                      <span class="loaderHolder"
                        ><Loader
                          v-show="processing"
                          color="secondary"
                          size="small"
                          text=""
                          class="loader-icon"
                        ></Loader
                      ></span>
                      <v-checkbox
                        v-model="localAccepted"
                        label="Don't show this popup again"
                        hide-details
                        color="white"
                        class="shrink accept-checkbox"
                        @click="acceptWelcome"
                      ></v-checkbox>
                    </div>
                  </div>
                  <div class="welcomImageHolder">
                    <img :src="welcomeImgSrc" alt="" class="welcomeImage" />
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
const EMITTED_ACTIONS = {
  ACCEPT_WELCOME: "accept-welcome",
  TOGGLE_DIALOG: "toggle-dialog",
};

export default {
  name: "GrdWelcomeMessageContent",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    accepted: {
      type: Boolean,
      default: false,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localAccepted: false,
    localShowDialog: false,
  }),
  mounted() {
    this.localAccepted = this.accepted;
    this.localShowDialog = this.showDialog;
  },
  computed: {
    backgroundImgSrc() {
      return require("@/assets/images/grd-welcome-background.png");
    },
    welcomeImgSrc() {
      return require("@/assets/images/grd-welcome-image.png");
    },
    downloadAppleSrc() {
      return require("@/assets/images/download_apple.png");
    },
    downloadAndroidSrc() {
      return require("@/assets/images/download_android.png");
    },
    linkedInSrc() {
      return require("@/assets/images/linkedin_logo.png");
    },
  },
  methods: {
    acceptWelcome() {
      this.$emit(EMITTED_ACTIONS.ACCEPT_WELCOME, this.localAccepted);
    },
  },
  watch: {
    localShowDialog: {
      handler() {
        this.$emit(EMITTED_ACTIONS.TOGGLE_DIALOG, this.localShowDialog);
      },
    },
  },
};
</script>

<style lang="scss">
.accept-checkbox .v-label {
  font-size: 14px !important;
  color: $secondary-color !important;
}
.accept-checkbox .v-icon {
  color: $secondary-color !important;
}
</style>

<style scoped lang="scss">
.close-icon-container {
  position: absolute;
  right: 40px;
  top: 30px;
  z-index: 2;
}
.text-container {
  position: absolute;
  left: 30px;
  top: 30px;
  width: calc(100% - 30px);
  background-color: transparent;
}
.highlighted-text {
  color: $primary-color;
  font-size: 28px;
  line-height: 34px;
}
.text-main {
  color: white;
  font-size: 16px;
  line-height: 24px;
}

.hr-light {
  border-top: none;
  border-bottom: 1px solid #cddb00;
}
.logo {
  margin-top: 80px;
}
.loader-icon {
  position: relative;
  bottom: 3px;
  min-width: 3ch;
}
.accepted-container {
  position: relative;
  top: 140px;
  right: 35px;
  width: 250px;
  z-index: 1;
}
.link-text {
  color: $secondary-color !important;
}
.button-cta {
  background-color: #00ae42;
  color: #fff;
  text-decoration: none;
  padding: 0.6rem 1.2rem;
  font-size: 18px;
  font-weight: 900;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 3px 5px rgba(0, 0, 0, 0.6);
  margin: 0.2rem 0 4rem 0;
  display: inline-block;
}

.flexContent {
  display: flex;
  flex-direction: column;
}

.flexToolbar {
  align-self: flex-end;
}

.flexMain {
  align-self: center;
}

.welcom-message-content {
  display: flex;
}

.welcom-message-content > div {
  padding: 10px;
}

.welcom-message-content-body {
  flex: 2;
}

.backgroundHolder {
  background-position: right bottom;
  background-size: 400px;
}

.welcomImageHolder {
  flex: 1;
  justify-content: center;
  display: flex;
}

.welcomeImage {
  width: 200px;
}

.acceptBoxHolder {
  display: flex;
}

.loaderHolder {
  position: absolute;
  margin-left: -20px;
  margin-bottom: 27px;
  bottom: 0;
}
</style>
